import { ResultsPanelTab } from "@/types/general";
import { markRaw } from "vue";
import Terminal16 from "@carbon/icons-vue/es/terminal/16";
import WarningAlt16 from "@carbon/icons-vue/es/warning--alt/16";
import Layers16 from "@carbon/icons-vue/es/layers/16";
import Meter16 from "@carbon/icons-vue/es/meter/16";

export const defaultTabs: Readonly<ResultsPanelTab[]> = [
	{
		name: "stdout",
		code: "Stdout",
		icon: markRaw(Terminal16),
		disabled: false,
		code_tag: true,
	},
	{
		name: "stderr",
		code: "Stderr",
		icon: markRaw(WarningAlt16),
		disabled: false,
		code_tag: true,
	},
	{
		name: "Build",
		code: "Build",
		icon: markRaw(Layers16),
		disabled: false,
		code_tag: false,
	},
	// {
	// 	name: "internals",
	// 	code: "Internals",
	// 	icon: "mdi-key",
	// 	text: "",
	// 	disabled: true,
	// 	code_tag: false,
	// },
	{
		name: "Runtime Information",
		code: "Stats",
		icon: markRaw(Meter16),
		// text: "",
		disabled: false,
		code_tag: false,
	},
	// {
	// 	name: "files",
	// 	code: "Files",
	// 	icon: "mdi-database-outline",
	// 	text: "",
	// 	disabled: false,
	// 	code_tag: false,
	// },
] as const;
